export default __webpack_public_path__ + "static/media/fundos-imobiliarios.4d46f529.svg";